import React from "react";
import "./Services.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";



const data = [
  {
    id: 1,
    title: "Facade / Glass Cleaning",
    description:
      "Our experts make your building's facade and glass surfaces shine, enhancing its overall appearance.",
    image: require("../../Assests/Images/facade.jpg"),
    descriptionPageLink: "/ServiceFacade",
  },
  {
    id: 2,
    title: "Deep Cleaning",
    image: require("../../Assests/Images/deepCleaning.jpg"),
    description:
      "Experience a thorough deep cleaning service that leaves your spaces sanitized and spotless.",
    descriptionPageLink: "/servicedeep",
  },
  {
    id: 3,
    title: "Diamond Marble Floor Polish",
    image: require("../../Assests/Images/diamond.jpg"),
    description:
      "Restore the shine and elegance of your marble floors with our diamond marble floor polishing service.",
    descriptionPageLink: "/servicediamond",
  },
  {
    id: 4,
    title: "Carpet / Sofa Dry Cleaning",
    image: require("../../Assests/Images/carpet.jpg"),
    description:
      "We provide professional dry cleaning for carpets, sofas, and chairs, ensuring they look fresh and clean.",
    descriptionPageLink: "/servicesofadry",
  },
  {
    id: 5,
    title: "White Wash Paint Work",
    image: require("../../Assests/Images/Whitewashing.jpg"),
    description:
      "Transform your spaces with our white wash paintwork services, giving your walls a vibrant look.",
    descriptionPageLink: "/servicewhitewash",
  },
  {
    id: 6,
    title: "Pest Control",
    image: require("../../Assests/Images/pest-control1.jpg"),
    description:
      "Experience peace of mind with our expert pest control services. Effective solutions for a pest-free space.",
    descriptionPageLink: "/pestcontrol",
  },
];

const DynamicCardImage = () => {
  return (
    <div className="services-wrapper">
      <h1 className="service-header">Our Services</h1>
      <div className="service-card-container">
        {data.map((item) => (
          <Card key={item.id} className="service-card">
            <div className="service-img-container">
              <img
                src={item.image}
                alt={item.title}
                className="service-img"
              />
            </div>
            <CardContent className="service-content">
              <h3 className="service-title">{item.title}</h3>
              <p className="service-description">{item.description}</p>
              <a href={item.descriptionPageLink} className="service-btn">
                SEE MORE →
              </a>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default DynamicCardImage;
